export default "__VITE_PUBLIC_ASSET__65183dbc__"